import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
	selector: 'app-confirm-change-dialog',
	templateUrl: './confirm-change-dialog.component.html',
	styleUrls: ['./confirm-change-dialog.component.scss'],
})
export class ConfirmChangeDialogComponent {
	constructor(@Inject(MAT_DIALOG_DATA) public additionalRoomSizeCharge: number) {}
}
